"use strict";
/**
  Voxeet AdapterJs to create peer connection from plugin or web navigator webrtc
*/
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.electronManager = exports.browser = exports.attachMediaStream = exports.isElectron = exports.isNode = exports.AudioContext = exports.RTCSessionDescription = exports.RTCIceCandidate = exports.RTCPeerConnection = void 0;
const ElectronManager_1 = __importDefault(require("../../extensions/ElectronManager"));
const loglevel_1 = __importDefault(require("loglevel"));
const Bowser = __importStar(require("bowser"));
const adapter_factory_1 = __importDefault(require("webrtc-adapter/src/js/adapter_factory"));
/**
 * @ignore
 */
const browser = Bowser.getParser(window.navigator.userAgent);
exports.browser = browser;
const isNode = !global.window;
exports.isNode = isNode;
//const isElectron = global.window && global.window.process && global.window.process.type;
const isElectron = browser.is('electron');
exports.isElectron = isElectron;
if (isNode) {
    global.Buffer = require('buffer').Buffer;
    global.WebSocket = require('ws');
    global.window = global.window || {};
    global.navigator = global.window || {};
    if (typeof btoa === 'undefined') {
        global.btoa = function (str) {
            return new Buffer(str).toString('base64');
        };
    }
    if (typeof atob === 'undefined') {
        global.atob = function (b64Encoded) {
            return new Buffer(b64Encoded, 'base64').toString();
        };
    }
}
else {
    adapter_factory_1.default(window, {
        shimChrome: false,
        shimFirefox: false,
        shimEdge: true,
        shimSafari: false,
    });
}
const electronManager = new ElectronManager_1.default();
exports.electronManager = electronManager;
var RTCIceCandidate = window.RTCIceCandidate || window.webkitRTCIceCandidate || window.mozRTCIceCandidate;
exports.RTCIceCandidate = RTCIceCandidate;
var RTCPeerConnection = window.RTCPeerConnection || window.webkitRTCPeerConnection || window.mozRTCPeerConnection;
exports.RTCPeerConnection = RTCPeerConnection;
var RTCSessionDescription = window.RTCSessionDescription || window.webkitRTCSessionDescription || window.mozRTCSessionDescription;
exports.RTCSessionDescription = RTCSessionDescription;
var AudioContext = window.AudioContext || window.webkitAudioContext || window.mozAudioContext;
exports.AudioContext = AudioContext;
const getUserMedia_ = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia;
navigator.getUserMedia = (constraints = {}) => {
    return new Promise((resolve, reject) => {
        getUserMedia_.call(window.navigator, constraints, (stream) => {
            resolve(stream);
        }, (error) => {
            reject(error);
        });
    });
};
if (navigator.mediaDevices && !browser.msedge && (!navigator.mediaDevices.getDisplayMedia || isElectron)) {
    navigator.mediaDevices.getDisplayMedia = (constraints) => __awaiter(void 0, void 0, void 0, function* () {
        let newConstraints = {};
        let sourceId = constraints && constraints.sourceId;
        // Function available on Electron that allows user to choose screen to share
        // and returns its sourceId
        if (window.getScreenSourceId) {
            sourceId = yield window.getScreenSourceId();
        }
        if (sourceId) {
            if (browser.is('electron') || browser.is('chrome')) {
                newConstraints = {
                    video: {
                        mandatory: {
                            chromeMediaSource: 'desktop',
                            chromeMediaSourceId: sourceId,
                            maxWidth: 1920,
                            maxHeight: 1080,
                        },
                    },
                };
            }
            else if (browser.is('firefox')) {
                newConstraints = {
                    video: {
                        mediaSource: constraints.sourceId,
                        maxWidth: 1920,
                        maxHeight: 1080,
                    },
                };
            }
        }
        return navigator.mediaDevices.getUserMedia(newConstraints);
    });
}
else if (browser.is('edge')) {
    navigator.mediaDevices.getDisplayMedia = navigator.getDisplayMedia.bind(navigator);
}
var isVoxeetPlugin = browser.isBrowser('ie', true);
var attachMediaStream = function (element, stream) {
    if (!isVoxeetPlugin) {
        if (typeof element.srcObject !== 'undefined') {
            if (browser.is('safari')) {
                const prevATracks = element.srcObject && element.srcObject.getAudioTracks();
                const nextATracks = stream && stream.getAudioTracks();
                if (element && element instanceof HTMLVideoElement) {
                    requestAnimationFrame(() => {
                        // Safari Fix CCS-212
                        element.srcObject = stream;
                    });
                }
                else if (!prevATracks ||
                    !nextATracks ||
                    prevATracks.length !== nextATracks.length ||
                    (prevATracks.length > 0 && nextATracks.length > 0 && prevATracks[0].id !== nextATracks[0].id)) {
                    // Replace only if track changed - CC-313
                    element.srcObject = stream;
                }
            }
            else {
                element.srcObject = stream;
            }
        }
        else if (typeof element.mozSrcObject !== 'undefined') {
            element.mozSrcObject = stream;
        }
        else if (typeof element.src !== 'undefined') {
            element.src = stream === null ? '' : URL.createObjectURL(stream);
        }
        else {
            loglevel_1.default.error('Error attaching stream to element.');
        }
    }
    else {
        if (element && element.nodeName === 'VIDEO') {
            if (element.videoRenderer) {
                VideoRenderer.unhandle(element);
            }
            VideoRenderer.handle(element);
        }
        element.srcObject = stream;
    }
    return element;
};
exports.attachMediaStream = attachMediaStream;
navigator.attachMediaStream = attachMediaStream;
